import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED } from '../../utils';
import { HotLaneDTO } from '../dtos';
import { HotLaneTable } from '../views';

export const HOT_LANE_TABLE = (hotLaneList: HotLaneDTO[]): HotLaneTable[] => {
	const result: HotLaneTable[] = [];
	try {
		if (IS_NOT_NULL_OR_UNDEFINED(hotLaneList) && hotLaneList.length > 0) {
			hotLaneList.forEach((hotLane) => {
				const hotLaneTable = {} as HotLaneTable;
				hotLaneTable.origin = `${hotLane.originCity},${hotLane.originState}`;
				hotLaneTable.destination = `${hotLane.destCity},${hotLane.destState}`;
				hotLaneTable.trailerTypes = formatTrailerTypes(hotLane.trailerTypes);
				hotLaneTable.searchCount = hotLane.searchCount;

				result.push(hotLaneTable);
			});
		}
	} catch (error) {
		console.log('HOT_LANE_TABLE error: ', error);
	}
	return result;
};

const formatTrailerTypes = (input: string): string => {
	let result = input;
	if (IS_NOT_EMPTY(input)) {
		result = input.split(',').reduce((pre, cur) => {
			pre += cur[0];
			return pre;
		}, '');
	}
	return result;
};
